export default {
    bindings: {
        accept: '@',
        currentUrl: '=',
        noPreview: '<',
        darkBackground: '<',
        type: '@'
    },
    require: {
        ngModel: 'ngModel'
    },
    controller: 'fileUploadController',
    template: require('../views/fileUpload.input.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/fileUpload.input.component.js